import { Injectable, inject } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService extends BaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public translateFile(translationRequest: FormData): Observable<any> {
    return this.postFile('v1/Translate/file', translationRequest);
  }
}
